const CAROUSEL = 'carousel';
const REELS = 'reels';
const STORIES = 'stories';
const FB_REELS = 'reels';
const POST = 'posts';
const PHOTOS = 'photos';

export default {
  CAROUSEL,
  REELS,
  STORIES,
  FB_REELS,
  POST,
  PHOTOS,
};
